module.exports = __webpack_public_path__ + "img/user.5cdba979.png";